import React from "react";

import Grid from "@material-ui/core/Grid";

import RecurrenceEnds from "./RecurrenceEnds";
import RecurrenceEvery from "./RecurrenceEvery";

import { getRecurrenceSentence } from "../../../utils/scheduler";

const RecurrenceDaily = (props) => {
  const { classes, formValues, changeParam } = props;

  return (
    <>
      <RecurrenceEvery
        classes={classes}
        formValues={formValues}
        changeParam={changeParam}
      />
      <RecurrenceEnds
        classes={classes}
        formValues={formValues}
        changeParam={changeParam}
      />
      <Grid item className="text-54" style={{ fontSize: "0.857em" }}>
        {getRecurrenceSentence("daily", formValues)}
      </Grid>
    </>
  );
};

export default RecurrenceDaily;
